import { HStack, Text, Select, SelectOptionProps } from '@televet/kibble-ui';
import React from 'react';
import { PaymentMedium } from 'shared/types/graphql';
import { InvoiceStatus } from 'shared/providers/StripeTerminalProvider';
import RefreshLink from '../RefreshLink';
import { IOption } from 'shared/components/Dropdown';

interface ITerminalPaymentProps {
  currentPaymentMedium: PaymentMedium;
  terminalOptions?: IOption[];
  terminalOption?: IOption;
  terminalMenuItems?: SelectOptionProps[];
  currentInvoiceStatus: InvoiceStatus;
  syncTerminalList: () => void;
  isInitialized: boolean;
  selectTerminalOption: (selectedItem: SelectOptionProps | undefined) => void;
}

const TerminalPayment = ({
  currentPaymentMedium,
  terminalOptions,
  terminalOption,
  terminalMenuItems,
  currentInvoiceStatus,
  syncTerminalList,
  isInitialized,
  selectTerminalOption,
}: ITerminalPaymentProps): JSX.Element | null => {
  const showComponent = currentPaymentMedium === PaymentMedium.StripeTerminal && terminalOptions?.length;

  if (!showComponent) {
    return null;
  }

  return (
    <>
      <HStack justifyContent="space-between">
        <Text size="sm" pt="4" pb="2">
          Select Terminal
        </Text>
        {currentInvoiceStatus === InvoiceStatus.Default && (
          <RefreshLink onClick={syncTerminalList} isLoading={!isInitialized} title="Sync Terminal List" />
        )}
      </HStack>
      <Select
        value={terminalOption?.value.id || ''}
        listProps={{
          isSearchable: true,
          onSelect: selectTerminalOption,
        }}
        isDisabled={currentInvoiceStatus !== InvoiceStatus.Default}
        options={terminalMenuItems || []}
      />
    </>
  );
};

export default TerminalPayment;
